<div class="dtf-accountdetails">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>
  <a id="mbfs-header-login-cta" id="auto_triggeraddress" class="mbfs-header-login-cta-a" href="javascript:void(0)"
  (click)="onClickPassword($event)" hidden></a>

  <div class="container_dashboard">
    <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 21px;">

      <div class="example-button-row">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
          <mat-button-toggle  [value]="toggleEnum.Option2">{{ 'AccountDetails.ChangePassword' | translate }}</mat-button-toggle>
          <mat-button-toggle  *ngIf="isAdmin==='true'" [value]="toggleEnum.Option3">Admin Portal</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="container_dashboard">
        <div class="mbfs-contact-us-page-inner" style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px;">
          <div *ngIf="SelectChangePassword">

            <form [formGroup]="manageProfileForm" (ngSubmit)="updateAndSaveNewPassword($event)" *ngIf="openLoginModal">
              <div class="mbfs-modal-content">
                <h1 class="mbfs-modal-header">{{ 'LoginModal.ChangePassword' | translate }}</h1>
                <div class="mbfs-bank-profile-create-inner">
                  <p class="mbfs-passwordreset-title">{{ 'LoginModal.SelectPassword' | translate }}</p>
                  <div class="testtext">
                    <li style="color:black;"
                      *ngIf="this.manageProfileForm.get('password') && this.manageProfileForm.get('password').errors && this.manageProfileForm.get('password').errors.pattern">
                      {{ 'LoginModal.SpecialCharacter' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasLowerCase">{{ 'LoginModal.MPLowerCase' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasUpperCase">{{ 'LoginModal.MPUpperCase' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasNumeric">{{ 'LoginModal.MPNumeric' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasMinimum">{{ 'LoginModal.MPMinimum' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.hasMaximum">{{ 'LoginModal.MPMaximum' | translate }}</li>
                    <li style="color:black;" *ngIf="!this.userIDcheck">{{ 'LoginModal.MPUserIdCheck' | translate }}</li>

                  </div><br>
                  <div class="mbfs-text-form" [ngClass]="formValidationClasses">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label for="password">{{ 'LoginModal.OldPassword' | translate }}</label>


                          <div class="col" style="display:flex;">
                            <input type="password" name="currentPassword" id="currentPassword" #password1
                              class="form-control" formControlName="currentPassword" required validateonblur value=""
                              onPaste="return false" autocomplete="off">
                              <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, hide)">
                                <span class="input-group-text" ><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                              </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <label for="password">{{ 'LoginModal.Password1' | translate }}</label>


                          <div class="col">
                            <div style="display:flex;">
                            <input class="form-control" type="password" name="password" id="password" #password2
                              formControlName="password" required validateonblur value="" onPaste="return false"
                              autocomplete="off" >
                              <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password2, hide1)">
                                <span class="input-group-text" ><i [ngClass]="hide1 ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                              </div></div>
                              <li style="color:black;"
                              *ngIf="this.manageProfileForm.get('password') && this.manageProfileForm.get('password').errors && this.manageProfileForm.get('password').errors.pattern">
                              {{ 'LoginModal.NotValidPassword' | translate }}</li>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <label for="password">{{ 'LoginModal.Password2' | translate }}</label>


                          <div class="col" >
                            <div style="display:flex;">
                            <input type="password" name="reTypePassword" id="reTypePassword" #password3
                              class="form-control" formControlName="reTypePassword" required validateonblur value=""
                              onPaste="return false" autocomplete="off">
                              <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password3, hide2)">
                                <span class="input-group-text" ><i [ngClass]="hide2 ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                              </div></div>
                              <li style="color:black;" *ngIf="!reentercheck">{{ 'LoginModal.PasswordNotMatch' | translate }}</li>

                          </div>
                        </div>


                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12 text-center">
                    <!--Spinner on Login Load-->
                      <div *ngIf="(!this.dataLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                        <div class="mbfs-loading-spinner-overlay"></div>
                        <div class="mbfs-loading-spinner"> </div>
                    </div>
                    <div *ngIf="agentview==='true'">
                      <button type="submit"  [disabled]="true" class="mbfs-button">{{ 'LoginModal.SavePassword' | translate }}</button>
                    </div>
                    <div *ngIf="agentview!='true'">
                      <button type="submit"  [disabled]="(this.manageProfileForm.get('reTypePassword').errors || this.disabledFlag)" class="mbfs-button">{{ 'LoginModal.SavePassword' | translate }}</button>
                    </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <span style="color:black;" *ngIf="this.serviceErrorOccurred">{{'LoginModal.InvalidCurrentPassword' | translate }}</span>
                    </div>
                    <div class="col-md-12 text-center">
                      <span style="color:#00566A;" *ngIf="this.currentPasswordDBCheckFlag">{{
                        'LoginModal.SuccessPassword' | translate }}</span>
                    </div>
                   
                  </div>
                </div>
              </div>

            </form>
          </div>      
          <div *ngIf="SelectAdmin">
            <div class="dtf-adminportal"></div>
          </div>   
        </div>
      </div>
    </div>
  </div>
</div>